import React, { FC } from 'react';
import {
  EntityFilterSelect,
  EntityFilterSelectProps,
} from '../../../common/table';
import { useAllClassifierCategoriesQuery } from '../../query/useAllClassifierCategoriesQuery';
import { CategoryCode } from '../../schema';

export interface CategorySelectProps
  extends Omit<EntityFilterSelectProps, 'options'> {
  code?: CategoryCode | string;
}

export const CategorySelect: FC<CategorySelectProps> = (props) => {
  const { code } = props;
  const { data = [], isFetching } = useAllClassifierCategoriesQuery(
    { classifierCode: code || '' },
    {
      enabled: Boolean(code),
    }
  );

  return (
    <EntityFilterSelect
      options={data}
      loading={isFetching}
      showCode={true}
      {...props}
    />
  );
};
